import Vue from "vue"

export const leadConfirmationState = Vue.observable({ current: null })
const waiting = []

function showNext() {
  if (!leadConfirmationState.current && waiting.length) leadConfirmationState.current = waiting.shift()
}

export function confirmLeadChanges(review) {
  return new Promise((resolve) => {
    waiting.push({ items: review.items || [], conflicts: review.conflicts || [], resolve })
    showNext()
  })
}

export function finishLeadConfirmation(confirmed, choices = {}) {
  const current = leadConfirmationState.current
  if (!current) return
  const selected = {}
  if (confirmed === true) for (const conflict of current.conflicts) {
    const choice = choices[conflict.key]
    if (!["update", "separate"].includes(choice) || (choice === "update" && !conflict.canUpdate)) return
    selected[conflict.key] = choice
  }
  leadConfirmationState.current = null
  current.resolve({ confirmed: confirmed === true, choices: selected })
  Vue.nextTick(showNext)
}
